import { NgModule } from '@angular/core';
import { MenuModule } from 'primeng/menu';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ConfirmationService, MessageService } from 'primeng/api';
import { EditorModule } from 'primeng/editor';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AccordionModule } from 'primeng/accordion';
import { EditableColumn, EditableRow, TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { FieldsetModule } from 'primeng/fieldset';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { ToolbarModule } from 'primeng/toolbar';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputMaskModule } from 'primeng/inputmask';
import { CalendarModule } from 'primeng/calendar';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { CarouselModule } from 'primeng/carousel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DividerModule } from 'primeng/divider';

@NgModule({
    declarations: [],
    imports: [
        MenuModule,
        InputTextModule,
        PasswordModule,
        MessageModule,
        MessagesModule,
        ButtonModule,
        CardModule,
        ConfirmDialogModule,
        PanelMenuModule,
        EditorModule,
        AutoCompleteModule,
        AccordionModule,
        TableModule,
        DropdownModule,
        CheckboxModule,
        FieldsetModule,
        DialogModule,
        RadioButtonModule,
        PanelModule,
        InputTextareaModule,
        InputNumberModule,
        ToastModule,
        ToolbarModule,
        MultiSelectModule,
        ProgressSpinnerModule,
        InputMaskModule,
        CalendarModule,
        DynamicDialogModule,
        ProgressBarModule,
        CarouselModule,
        ScrollPanelModule,
        InputSwitchModule,
        DividerModule
    ],
    exports: [
        MenuModule,
        InputTextModule,
        PasswordModule,
        MessageModule,
        MessagesModule,
        ButtonModule,
        CardModule,
        ConfirmDialogModule,
        PanelMenuModule,
        EditorModule,
        AutoCompleteModule,
        AccordionModule,
        TableModule,
        DropdownModule,
        CheckboxModule,
        FieldsetModule,
        DialogModule,
        RadioButtonModule,
        PanelModule,
        InputTextareaModule,
        InputNumberModule,
        ToastModule,
        ToolbarModule,
        MultiSelectModule,
        ProgressSpinnerModule,
        InputMaskModule,
        CalendarModule,
        ProgressBarModule,
        CarouselModule,
        ScrollPanelModule,
        InputSwitchModule,
        DividerModule
    ],
    providers:
    [
        ConfirmationService,
        MessageService,
        EditableRow,
        EditableColumn,
        DialogService
    ]
})
export class PrimengModule { }
